import { Provider } from "@redotech/redo-order-common/provider";
import type { StorefrontPlatform } from "@redotech/redo-storefront-common/storefront-config";

/** Providers that render a Redo storefront widget. Others have no platform. */
export const STOREFRONT_PLATFORM_BY_PROVIDER: Partial<
  Record<Provider, StorefrontPlatform>
> = {
  [Provider.SHOPIFY]: "shopify",
  [Provider.COMMERCE_CLOUD]: "commerce-cloud",
  [Provider.COMMENTSOLD]: "commentsold",
  [Provider.BIGCOMMERCE]: "bigcommerce",
};
